const AboutSection = () => {
  const stats = [
    { number: '15+', label: 'Années d\'expérience' },
    { number: '200+', label: 'Projets réalisés' },
    { number: '50+', label: 'Artisans qualifiés' },
    { number: '98%', label: 'Clients satisfaits' }
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Qualité Garantie',
      description: 'Nous utilisons uniquement des matériaux de première qualité et respectons les normes les plus strictes.'
    },
    {
      icon: 'ri-time-line',
      title: 'Respect des Délais',
      description: 'Nos équipes sont formées pour livrer vos projets dans les temps impartis, sans compromis sur la qualité.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Service Client',
      description: 'Un accompagnement personnalisé tout au long de votre projet avec un interlocuteur dédié.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Éco-responsable',
      description: 'Nous privilégions les solutions durables et respectueuses de l\'environnement dans tous nos projets.'
    }
  ];

  return (
    <section id="apropos" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
              À propos de <span className="text-blue-600">GLOBAL GRACE ENGINEERING</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              GLOBAL GRACE ENGINEERING est une société basée en République Démocratique du Congo, 
              fournissant à ses clients des prestations de premier ordre dans les deux secteurs clés 
              que sont le bâtiment et l'entretien.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              Notre longévité et la qualité exceptionnelle de nos prestations, maintes fois démontrées 
              et qui surpassent la concurrence, nous positionnent comme des collaborateurs de choix pour 
              notre clientèle.
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Cela est rendu possible par notre principe directeur : <strong className="text-blue-600">Bâtir avec excellence, restaurer avec grâce.</strong>
            </p>
            <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              Global Grace Engineering se distingue comme une entité flexible et proactive, experte à la fois 
              dans les projets de construction neufs et les opérations de maintenance.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/e68c75914c68b0df4c9ac6eb3f20a66f.jpeg"
              alt="Équipe Global Grace Engineering"
              className="rounded-xl shadow-lg object-cover object-top w-full h-64 sm:h-80 md:h-96"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl p-5 sm:p-6 text-center shadow-lg">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className={`${value.icon} text-xl sm:text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2 sm:mb-3">{value.title}</h3>
              <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
